import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import priorhealth from "../../assets/images/prior_health.jpg"
export default function PriorHcore() {
  return (
    <section className="relative w-full bg-[#F8FAFC] lg:py-24 md:py-16 py-10 px-6 sm:px-8 lg:px-12 border-b border-slate-200/80 font-sans overflow-hidden">
      <div
        className="pointer-events-none absolute top-0 left-0 w-full h-full opacity-20 "
        style={{
          background:
            "linear-gradient(135deg, #62d4f7 0%, #5dc9f0 40%, #3579be 60%",
        }}
      />
      <div className="xl:w-4/5 mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-7 space-y-4">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4 }}
              className="inline-flex items-center gap-2 px-0.5 py-1.5 backdrop-blur-md shadow-xs"
            >
              <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-700">
                PURPOSE &amp; SCOPE
              </span>
            </motion.div>
            <div className="space-y-4">
              <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-slate-950 leading-tight">
                Clinical Decisions into <br />
                <span className="italic font-serif font-normal text-[#5dc9f0]">
                  Instant Actions
                </span>
              </h2>

              <p className="text-base sm:text-lg text-slate-600 leading-relaxed font-normal">
                Prior Authorization was designed to control costs, but it has
                evolved into one of the heaviest administrative burdens in
                healthcare—forcing clinicians to spend up to 13 hours weekly
                navigating fragmented portals, faxes, and clinical guidelines.
              </p>

              <p className="text-sm sm:text-base text-slate-600 leading-relaxed font-normal">
                Our service bridges the interoperability divide by uniting{" "}
                <strong>Camunda 8 orchestration</strong> with{" "}
                <strong>SMART on FHIR</strong>. We extract required clinical
                context right at the point of care, execute rules directly
                against payer coverage policies, and deliver immediate approvals
                without taking doctors away from their patients.
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5 pt-2">
              {[
                "Direct in-EHR clinical data capture",
                "Automated Da Vinci CRD & DTR checks",
                "Sub-minute straight-through approvals",
                "Complete CMS-0057-F mandate readiness",
              ].map((item, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2.5 text-xs sm:text-sm font-medium text-slate-800"
                >
                  <CheckCircle2 className="w-4 h-4 text-[#5dc9f0] shrink-0" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="lg:col-span-5 relative">
            <div className="lg:col-span-5 relative flex">
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
                className="relative w-full h-[520px] lg:h-full min-h-[480px] rounded-xl overflow-hidden bg-[#000036] shadow-[0_25px_60px_rgba(0,0,0,0.08)] border border-black/10 flex flex-col justify-between p-8 sm:p-8"
              >
                <img
                  src={priorhealth}
                  alt="Intelligent Systems Architecture"
                  className="absolute inset-0 h-full w-full object-cover grayscale-[15%] contrast-110 opacity-70"
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#000036] via-[#000036]/10 to-[#000036]/20" />
                <div className="relative z-10 flex items-center justify-between"></div>
                <div className="relative z-10 p-4 rounded-xl bg-[#000036] backdrop-blur-xl  shadow-md">
                  <h4 className="font-display text-base font-bold text-white leading-snug">
                    HL7® FHIR® R4 Orchestration
                  </h4>
                  <p className="mt-1 text-sm text-white font-normal leading-relaxed">
                    Unifying EHR patient charts with payer coverage rules in
                    real time.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
